import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
    modeIconMapRedesign,
} from 'wanderu-assets';
import {
    TooltipController,
    TooltipSelect,
} from 'wanderu-components';
import { combineClasses } from 'wanderu-css';
import {
    localize,
} from 'wanderu-i18n';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './TripModes.scss';

function TripMode(props) {
    const {
        classes,
        index,
        mode,
        t,
    } = props;

    const Icon = modeIconMapRedesign[mode];

    return (
        <div
            className={classnames(
                classes.iconContainer,
                {
                    [classes.offsetOne]: index === 1,
                    [classes.offsetTwo]: index === 2,
                },
            )}
        >
            <TooltipController offsetX="center">
                <TooltipSelect>
                    <Icon
                        className={classes.icon}
                        title={t(`baseApp:${mode}`)}
                    />
                </TooltipSelect>
                <div>
                    {t(`baseApp:${mode}`)}
                </div>
            </TooltipController>
        </div>
    );
}

TripMode.propTypes = {
    classes: PropTypes.object,
    index: PropTypes.number,
    mode: PropTypes.string,
    t: PropTypes.func,
};

const LocalizeTripMode = localize(TripMode);

function TripModes(props) {
    const {
        className = '',
        classes: classesProp,
        modes,
    } = props;

    const classes = combineClasses(classesProp, styles);

    return (
        <div
            className={classnames(
                classes.tripModes,
                className,
                {
                    [classes.withTwoTripModes]: modes.length === 2,
                    [classes.withThreeTripModes]: modes.length === 3,
                },
            )}
        >
            {modes.map((mode, index) => (
                <LocalizeTripMode
                    classes={classes}
                    index={index}
                    key={mode}
                    mode={mode}
                />
            ))}
        </div>
    );
}

TripModes.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    modes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export {
    TripModes,
};

export default localize(TripModes);
